import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/ubuntu/html/tablespace-website/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/home/ubuntu/html/tablespace-website/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MaskReveal"] */ "/home/ubuntu/html/tablespace-website/components/Motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InvestorTabs"] */ "/home/ubuntu/html/tablespace-website/components/sections/InvestorTabs.tsx");
